import React, { Fragment, useEffect, useState, useRef } from "react";
import { TabContent, TabPane } from "reactstrap";
import Pagination from "@material-ui/lab/Pagination";

import exclamation_light from "styles/common/img/mypage/exclamation_light.png";
import exclamation_dark from "styles/common/img/mypage/exclamation_dark.png";
import { ANOUN_LIST_REQUEST, ANOUN_DETAILED_REQUEST, ANOUN_ARRAY_PASS } from "containers/csboard/Action";
import { useSelector, useDispatch } from "react-redux";
import file_icon from "styles/common/img/mypage/file_icon.png";
import file_icon_dark from "styles/common/img/mypage/file_icon_dark.png";
import { hideKeyboard } from "bridge/common/CommonBridge";

import CustomSelectBox from "utils/CustomSelectBox";

const Notice_list = (props) => {
    const dispatch = useDispatch();
    const inputRef = useRef();
    const { user_id, anounNimptList, anounImptList, mode, reloadState } = props;

    const [activeTab] = useState("1");
    const [textVal, setTextVal] = useState("");
    const [searchType, setSearchType] = useState("");
    const [state, setState] = useState(1);
    const [disabledBtn, setDisabledBtn] = useState(false);

    const anounCnt = useSelector((state) => state.csboardReducer.anounCnt);

    const [totalCnt, setTotalCnt] = useState({
        dataCnt: 0,
        pageCnt: 0,
    });

    const [srchCondition, setSrchCondition] = useState({
        size: 10,
        pageIndex: 1,
    });

    useEffect(() => {
        if (anounCnt === 0) {
            setTotalCnt({
                ...totalCnt,
                dataCnt: 0,
                pageCnt: 1,
            });
        } else {
            setTotalCnt({
                ...totalCnt,
                dataCnt: Number(anounCnt),
                pageCnt: Math.ceil(Number(anounCnt) / 10),
            });
        }
    }, [anounCnt]);

    useEffect(() => {
        if (reloadState === "1") {
            dispatch(
                ANOUN_LIST_REQUEST({
                    headerParam: user_id,
                    searchType: "",
                    keyword: "",
                    from: 0,
                    size: 10,
                }),
            );
            setSearchType("");
            setTextVal("");
            setSrchCondition({
                ...srchCondition,
                pageIndex: 1,
                size: 10,
            });
        }
    }, [reloadState]);

    const handleSearch = () => {
        dispatch(
            ANOUN_LIST_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: textVal,
                from: 0,
                size: 10,
            }),
        );

        setState(state + 1);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
            hideKeyboard();
        }
    };

    let imptArr = [];
    let NimptArr = [];
    let imptSeq = [];
    let nimptSeq = [];

    for (var obj in anounImptList) {
        imptArr[obj] = anounImptList[obj];
    }

    for (var obj in anounNimptList) {
        NimptArr[obj] = anounNimptList[obj];
    }

    //일반공지사항 총 개수
    const nimptLength = anounCnt;
    //중요공지사항 총 개수
    const imptLength = imptArr.length;

    const seqArray = {
        imptMaxSeq: anounCnt + imptLength,
        nimptMaxSeq: nimptLength,
    };

    const anounTotalcnt = nimptLength + imptLength;

    useEffect(() => {
        setDisabledBtn(false);
        if (imptLength + nimptLength <= 1) setDisabledBtn(true);
    }, [anounTotalcnt]);

    useEffect(() => {
        if (imptLength > 0) {
            imptArr.map((ele, i) => {
                ele.INDEX = anounCnt + (imptLength - i);
                imptSeq.push(ele.ANOUN_SEQ);
            });
        }

        if (nimptLength > 0) {
            NimptArr.map((ele, i) => {
                ele.INDEX = anounCnt - i;
                nimptSeq.push(ele.ANOUN_SEQ);
            });
        }
    }, [imptArr, NimptArr]);

    //게시글 제목 클릭 시
    const handleDetail = (chkRowSeq) => {
        dispatch(
            ANOUN_DETAILED_REQUEST({
                headerParam: user_id,
                anounSeq: chkRowSeq,
            }),
        );
        dispatch(
            ANOUN_ARRAY_PASS({
                searchType: searchType,
                searchTxt: textVal,
                seqArray: seqArray,
                disabledBtn: disabledBtn,
            }),
        );
    };

    // 페이징 변경
    const handlePageChange = (event, value) => {
        setSrchCondition({
            ...srchCondition,
            pageIndex: Number(value),
            size: Number(value) * 10,
        });
    };

    //페이징이 변경될때 요청되는 api
    useEffect(() => {
        dispatch(
            ANOUN_LIST_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: textVal,
                from: srchCondition.size - 10,
                size: 10,
            }),
        );
    }, [srchCondition]);

    //중요표시 있는 리스트
    const imptList = imptArr.map((ele, i) => (
        <div
            key={i}
            className="td-padding"
            onClick={() => {
                handleDetail(ele.ANOUN_SEQ);
            }}
        >
            <span className="newcell newcol1 subject position-relative">
                <span className="important-card">중요</span>
            </span>
            <span className="newcell newcol1 cursor">{ele.SEARCH_TYPE}</span>
            <span className="newcell newcol8 px-16 ">
                <span className="list-title">{ele.ANOUN_TITE}</span>
                {ele.FILE_YN === "Y" ? (
                    <Fragment>
                        {mode ? (
                            <img src={file_icon} className="fl whiteMode-img" />
                        ) : (
                            <img src={file_icon_dark} className="fl darkMode-img" />
                        )}
                    </Fragment>
                ) : (
                    ""
                )}
            </span>
            <span className="newcell newcol1">{ele.BRWS_CNT}</span>
            <span className="newcell newcol1 hit">{ele.REG_DTM}</span>
        </div>
    ));

    //중요표시 없는 리스트
    const nimptList = NimptArr.map((ele, i) => {
        //현재 렌더링되는 일반공지사항 개수
        const currentLength = NimptArr.length;
        let flag = false;
        if (currentLength === i + 1) flag = true;
        return (
            <div
                key={i}
                className={!flag ? "td-padding" : "td-padding bdb-none"}
                onClick={() => handleDetail(ele.ANOUN_SEQ)}
            >
                <span className="newcell newcol1">
                    {totalCnt.dataCnt - (Number(srchCondition.pageIndex) - 1) * 10 - i}
                </span>
                <span className="newcell newcol1">{ele.SEARCH_TYPE}</span>
                <span className="newcell newcol8 px-16">
                    <span className="cs-list-title">{ele.ANOUN_TITE}</span>
                    {ele.FILE_YN === "Y" ? (
                        <Fragment>
                            {mode ? (
                                <img src={file_icon} className="fl whiteMode-img" />
                            ) : (
                                <img src={file_icon_dark} className="fl darkMode-img" />
                            )}
                        </Fragment>
                    ) : (
                        ""
                    )}
                </span>
                <span className="newcell newcol1">{ele.BRWS_CNT}</span>
                <span className="newcell newcol1"> {ele.REG_DTM}</span>
            </div>
        );
    });

    const render = {
        all: [imptList, nimptList],
        emptyArray: (
            <div className="no-file-wrap">
                <div className="no_file mark_position clear">
                    {mode ? (
                        <img src={exclamation_light} alt="경고" className="whiteMode-img" />
                    ) : (
                        <img src={exclamation_dark} alt="경고" className="darkMode-img" />
                    )}
                    등록된 공지사항이 없습니다.
                </div>
            </div>
        ),
        emptySearchResult: (
            <div className="no-file-wrap">
                <div className="no_file mark_position clear">
                    {mode ? (
                        <img src={exclamation_light} alt="경고" className="whiteMode-img" />
                    ) : (
                        <img src={exclamation_dark} alt="경고" className="darkMode-img" />
                    )}
                    검색 된 결과가 없습니다.
                </div>
            </div>
        ),
    };

    let currentValue;

    if (imptLength > 0 || nimptLength > 0) {
        currentValue = "all";
    } else if (imptLength === 0 || nimptLength === 0) {
        switch (state) {
            case 1:
                currentValue = "emptyArray";
                break;
            default:
                currentValue = "emptySearchResult";
                break;
        }
    }

    //셀렉트 옵션 기준 정렬
    useEffect(() => {
        // if(searchType!==""){
        dispatch(
            ANOUN_LIST_REQUEST({
                headerParam: user_id,
                searchType: searchType,
                keyword: textVal,
                from: 0,
                size: 10,
            }),
        );
        setState(state + 1);
        //}
        setSrchCondition({
            ...srchCondition,
            pageIndex: 1,
            size: 10,
        });
    }, [searchType]);

    const optionItemList = [
        {
            itemName: "전체",
            value: "",
        },
        {
            itemName: "서비스",
            value: "A",
        },
        {
            itemName: "강좌",
            value: "B",
        },
    ];

    return (
        <>
            {/* 2022-02-17 19002004 커스템셀렉트박스 변경  */}
            <div className="NoticeList position-relative">
                <div className="undertab_tabs clear">
                    <div className="fl">
                        <div className="fl top_select1">
                            <CustomSelectBox
                                optionItemList={optionItemList}
                                clickEvent={setSearchType}
                                defaultType={"ALL"}
                            />
                        </div>
                    </div>
                    {/* <div className="fl">
                        <select
                            name=""
                            className="cs-select"
                            value={searchType}
                            onChange={(e) => setSearchType(e.currentTarget.value)}
                        >
                            <option value="" className="selcet_category">
                                전체
                            </option>
                            <option value="A" className="selcet_category">
                                서비스
                            </option>
                            <option value="B" className="selcet_category">
                                강좌
                            </option>
                        </select>
                    </div> */}
                    <div className="fr">
                        <div className="d_inb fl black-m-input">
                            <input
                                id="search_keyWord"
                                type="text"
                                className="form-control"
                                placeholder="검색어를 입력해 주세요."
                                onChange={(e) => {
                                    setTextVal(e.currentTarget.value);
                                }}
                                onKeyPress={handleKeyPress}
                                ref={inputRef}
                                value={textVal}
                            />
                        </div>
                        <div className="fl ">
                            <button className="black-s-btn" onClick={handleSearch}>
                                검색
                            </button>
                        </div>
                    </div>
                </div>
                <div className="undertab_tab-bg">
                    <TabContent activeTab={activeTab} className="undertab-content">
                        <TabPane tabId="1">
                            <div id="notice-table">
                                <div className="th-padding title-padding-s">
                                    <span className="newcell newcol1">번호</span>
                                    <span className="newcell newcol1">구분</span>
                                    <span className="newcell newcol8">제목</span>
                                    <span className="newcell newcol1">조회수</span>
                                    <span className="newcell newcol1">등록일</span>
                                </div>
                                {/* <div className=""> */}
                                {/* </div><div className="td-padding"> */}
                                {/* <div> */}
                                {render[currentValue]}
                                {/* </div>   */}
                                {/* </div>   */}
                            </div>
                        </TabPane>
                    </TabContent>
                    <div className="pagination dp_b">
                        <Pagination
                            count={totalCnt.pageCnt}
                            page={srchCondition.pageIndex}
                            onChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default React.memo(Notice_list);
